import ApiResponse from "../models/apiResponse";
import apiClient from "./client";
import Util from "./util";
import ProfileProperties from "../models/profileProperties";

export default {
  async fetchProfile(): Promise<ApiResponse> {
    const url = "/api/v1/profile";
    return await apiClient.get(url, { headers: Util.authHeaders() });
  },
  async fetchSessions(): Promise<ApiResponse> {
    const url = "/api/v1/profile/sessions";
    return await apiClient.get(url, { headers: Util.authHeaders() });
  },
  async login(email: string, pass: string): Promise<ApiResponse> {
    const url = "/api/v1/auth/login";
    const params = { email: email, password: pass };

    return await apiClient.post(url, params);
  },
  async logout(): Promise<ApiResponse> {
    const url = "/api/v1/auth/logout";
    return await apiClient.post(url, "", { headers: Util.authHeaders() });
  },
  async register(
    name: string,
    email: string,
    pass: string,
  ): Promise<ApiResponse> {
    const url = "/api/v1/auth/register";
    const params = { name: name, email: email, password: pass };

    return await apiClient.post(url, params);
  },
  async requestPasswordReset(email: string | null): Promise<ApiResponse> {
    const url = "/api/v1/auth/forgot-password";
    const params = { email: email };

    return await apiClient.post(url, params);
  },
  async resetPassword(
    token: string | null,
    password: string | null,
  ): Promise<ApiResponse> {
    const url = "/api/v1/auth/password";
    const params = { token: token, password: password };

    return await apiClient.put(url, params);
  },
  async updateProfile(properties: ProfileProperties): Promise<ApiResponse> {
    const url = "/api/v1/profile";

    return await apiClient.put(url, properties, {
      headers: Util.authHeaders(),
    });
  },
  async updateProfileAvatar(file: File): Promise<ApiResponse> {
    const url = "/api/v1/profile/avatar";
    const params = new FormData();
    params.append("avatar", file);

    return await apiClient.put(url, params, { headers: Util.authHeaders() });
  },
};
